module.exports = __webpack_public_path__ + "img/mq.0ad3fa97.jpg";